export default __webpack_public_path__ + "media/images/633328-4130540add199b3a39de9b02ba9a9de2.png";